import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "@/helpers/variables";

import BeforeAfterBreadcrumbs from "@/components/before-after-breadcrumbs/index.vue";
import CategoryCard from "@/modules/pages/before-after-category/components/category-card/index.vue";
import CustomPagination from "@/components/custom-pagination/index.vue";

export default {
  name: "BeforeAfterCategory",

  components: { BeforeAfterBreadcrumbs, CategoryCard, CustomPagination },

  data() {
    return {
      page: 1,
      perPage: 6,
      total: 0,
      windowSize: window.innerWidth,
    };
  },

  computed: {
    ...mapGetters({
      cases: "beforeAfter/cases",
      casesMeta: "beforeAfter/casesMeta",
      categories: "beforeAfter/categories",
    }),

    isMobile() {
      return this.windowSize <= 768;
    },

    categorySlug() {
      return this.$route.params.category;
    },

    currentCategoryName() {
      if (!this.categories) return null;
      const found = this.categories.find(c => c.slug === this.categorySlug);
      return found?.name || null;
    },
  },

  watch: {
    page() {
      if (this.isMobile) return;
      this.fetchList();
    },

    categorySlug() {
      this.page = 1;
      this.fetchList(true);
    },
  },

  mounted() {
    window.addEventListener("resize", this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },

  methods: {
    ...mapActions({
      fetchCases: "beforeAfter/FETCH_BEFORE_AFTER_CASES",
    }),

    handleResize() {
      const prevIsMobile = this.isMobile;
      this.windowSize = window.innerWidth;
      const nextIsMobile = this.isMobile;
      if (prevIsMobile !== nextIsMobile) {
        this.page = 1;
        this.fetchList(true);
      }
    },

    async fetchList(reset = false) {
      try {
        globalLoader(true);

        if (reset) {
          this.$store.commit("beforeAfter/RESET_BEFORE_AFTER_CASES");
        }

        const perPage = this.isMobile ? 1000 : this.perPage;
        const page = this.isMobile ? 1 : this.page;

        await this.fetchCases({
          categorySlug: this.categorySlug,
          perPage,
          load: "paginate",
          page,
        });

        this.total = this.isMobile ? this.cases?.length || 0 : this.casesMeta?.total || 0;
      } catch (e) {
        console.error("ERROR FETCHING CASES:", e);
      } finally {
        globalLoader(false);
      }
    },
  },

  async created() {
    await this.fetchList(true);
  },
};
